import { render } from "./InvoiceMonitorTab.vue?vue&type=template&id=cc1c1976&scoped=true"
import script from "./InvoiceMonitorTab.vue?vue&type=script&lang=js"
export * from "./InvoiceMonitorTab.vue?vue&type=script&lang=js"

import "./InvoiceMonitorTab.vue?vue&type=style&index=0&id=cc1c1976&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1c1976"]])

export default __exports__